import config from "@/config";
import { flvApiUrl } from "@/utils/constant";
const {afterResponse} = config.request
export function post(url, data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return send(url, {
    method: "POST",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

function send(url, config) {
  return fetch(flvApiUrl + url, config)
    .then((response) => response.json())
    .then(afterResponse);
}

const baseUrl = "dal/";
export default {
  IothubMessage: (params) => {
    return post(baseUrl + "dal-telecom-camera-cloud/iothub-message", params);
  },
};
